export default __webpack_public_path__ + "img/b.51b601d2.png";